/*
 * Created by guandong.ni on 17/10/27.
 * 获取验证码接口，此为调用北京的获取验证码接口。使用时请尽量了解需求再用。
 */
import ajax from './ajax.jquery';
import toast from './toast.jquery';
import {getQuery} from './uri';
import {report} from './report';
import es from './es';
// const inputMobiles = {};
let sending = false;
export function send(param, infoTextOption) {
  'use strict';
  let infoText = es.objectAssign({
    // OLD_USER: '您已是注册用户\n请直接登录参与!',
    notToastCode: [],
  }, infoTextOption);
  // 请求服务器发送验证码
  return new Promise((resolve, reject) => {
    if (sending) {
      toast('请勿重复提交');
      reject({
        errCode: 9000,
        errInfo: '请勿重复提交',
      });
      return;
    }
    if (!param.mobile.toString().match(/^(86){0,1}1\d{10}$/)) {
      toast('请输入正确的手机号码');
      reject({
        errCode: 9000,
        errInfo: '请输入正确的手机号码',
      });
      return;
    }
    let _url = '/h5/user/check_register';
    sending = true;
    ajax.post(_url, {
      data: Object.assign({
        os: 'h5',
        _srcid: param.source || getQuery('source') || "",
      }, param),
      complete: () => {
        sending = false;
      },
    }).then(data => {
      let errInfo = data.errstr;
      if (data.errcode == 0) {
        if (data.data.isNeedCaptcha) {
          errInfo = '请先填写图形验证码';
          toast(errInfo);
        } else {
          return resolve(data, param.mobile);
        }
      } else if (data.errcode == -2000) {
        // 老用户
        report(infoText.reportOldUser);
        if (infoText.OLD_USER) {
          errInfo = infoText.OLD_USER;
        }
        if (infoText.notToastCode.indexOf(data.errcode) === -1) {
          toast(errInfo);
        }

        //需要跳转至老用户结果页
      } else if (data.errcode == -27) {
        errInfo = '请输入图片验证码计算结果';
        toast(errInfo);
      } else if (data.errcode == -28) {
        errInfo = '图形验证码错误，请重新输入';
        toast(errInfo);
      } else if (data.errcode == -1000) {
        errInfo = '验证码错误，请重新输入';
        toast(errInfo);
      } else if (data.data.isNeedCaptcha) {
        errInfo = '请先填写图形验证码';
        toast(errInfo);
      } else {
        toast(errInfo.replace(/<[^>]*>/g, ''));
      }
      reject(Object.assign(data, {
        errCode: data.errcode,
        errInfo,
        data: data.data,
      }));
    }).catch(e => {
      console.log(e);
      toast('网络错误，请稍候再试！');
      reject({
        errCode: 9000,
        errInfo: '网络错误，请稍候再试！',
      });
    });
  });
}
export default {
  send,
  removeHistory(){
    //此接口不需记历史号码，定义此方法为兼容smsCode.xiaoying.js可完美切换
  },
};



// WEBPACK FOOTER //
// ./src/component/common/smsCode.cardloan.js